import {
    CALL_AVERAGE_TASKS_SUCCESS,
    CALL_AVERAGE_TASKS_FAIL,
    SET_MESSAGE,
    CALL_AVERAGE_TASKS_PENDING,
  } from "../types";
  import UserService from "../../services/user.service";
  import { toast } from "react-toastify";
  
  export const getCallAveragTasks = (body) => async (dispatch) => {
    dispatch({
      type: CALL_AVERAGE_TASKS_PENDING,
      payload: { callAvgTasks: "isLoading" },
    });
    return await UserService.getCallAvgTasks(body)
      .then(
        (data) => {
          console.log(data);
          data.data.status
            ? dispatch({
                type: CALL_AVERAGE_TASKS_SUCCESS,
                payload: { callAvgTasks: data.data.result[0] },
              })
            : dispatch({
                type: CALL_AVERAGE_TASKS_FAIL,
              });
          return Promise.resolve();
        },
        (error) => {
          console.log("error......", error);
          const message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
  
          dispatch({
            type: CALL_AVERAGE_TASKS_FAIL,
          });
  
          dispatch({
            type: SET_MESSAGE,
            payload: message,
          });
  
          return Promise.reject();
        }
      )
      .catch((error) => {
        console.log(error);
      });
  };
  